import { ButtonProps } from '@mui/material';
import { atomWithReset } from 'jotai/utils';

const pageHeaderButtonsAtom = atomWithReset<ButtonProps[] | null>(null);

export default pageHeaderButtonsAtom;
